export const getComments = (payload?: any) => ({
  type: "@saga/GET_COMMENTS",
  payload,
});
